<template>
<div>
  <input
    @input="$emit('input', true)"
    :name="randomName"
    type="radio"
    :value="value"
    :checked="value === true"
  />
  <span>Sim</span>

  <input
    @input="$emit('input', false)"
    type="radio"
    :name="randomName"
    :value="value"
    :checked="value === false"
  />
  <span>Não</span>
</div>
</template>

<script>
export default {
  name: 'YesNoRadio',
  props: ['value'],
  computed: {
    randomName () {
      return Math.random() * Math.random() * 10000
    }
  }
}
</script>

<style scoped>
  span {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Trg/YesNoRadio.vue